(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srl-bonbon-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (root.dataset.carouselReady) return;
      root.dataset.carouselReady = '1';

      var scope = root.closest('.srl-carousel') || root.parentElement;
      var track = root.querySelector('[data-carousel-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.srl-carousel__slide'));
      var caption = scope.querySelector('[data-carousel-caption]');
      var dots = Array.prototype.slice.call(scope.querySelectorAll('[data-carousel-dot]'));
      if (!track || slides.length === 0) return;
      var index = 0;

      function update() {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        if (caption) caption.textContent = slides[index].getAttribute('data-name') || '';
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }
      function go(n) { index = (n + slides.length) % slides.length; update(); }

      var prev = root.querySelector('[data-carousel-prev]');
      var next = root.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-carousel-dot'), 10)); });
      });

      var startX = null;
      root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? index + 1 : index - 1); }
        startX = null;
      }, { passive: true });

      update();
    }

    function initAll() {
      document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // Theme editor: re-init sections that are added/reloaded
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srl-header"]) return;
  try {
    
  (function () {
    var headers = document.querySelectorAll('[data-srl-header]');
    headers.forEach(function (header) {
      var overlay = header.hasAttribute('data-srl-overlay');
      var toggle = header.querySelector('[data-srl-toggle]');
      var mobile = header.querySelector('[data-srl-mobile]');

      if (overlay) {
        var onScroll = function () {
          header.classList.toggle('is-scrolled', window.scrollY > 50);
        };
        document.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      if (toggle && mobile) {
        toggle.addEventListener('click', function () {
          var open = mobile.hasAttribute('hidden');
          if (open) {
            mobile.removeAttribute('hidden');
          } else {
            mobile.setAttribute('hidden', '');
          }
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srl-hero"] && !Shopify.designMode) return;
  try {
    
  // Light-weight parallax — no external deps.
  (function () {
    var els = document.querySelectorAll('[data-srl-parallax]');
    if (!els.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function tick() {
      var y = window.scrollY;
      els.forEach(function (el) {
        var rect = el.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return;
        el.style.transform = 'translate3d(0,' + Math.min(y * 0.3, 150) + 'px,0)';
      });
    }
    document.addEventListener('scroll', function () {
      requestAnimationFrame(tick);
    }, { passive: true });
    tick();
  })();

  } catch(e) { console.error(e); }
})();
})();
